import { forwardRef } from 'react';
import { wrapperCls, iframeCls, subheadingCls, bodyCls } from './empty.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Empty = /*#__PURE__*/forwardRef(function Empty(props, ref) {
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: wrapperCls,
    children: [/*#__PURE__*/jsx("iframe", {
      className: iframeCls,
      "aria-hidden": true,
      sandbox: "allow-scripts",
      src: "https://portalmotor.gyldendal.dk/-/media/home/web/idas-showroom/billeder/InSiteAd/Still-TomtForlob.svg",
      width: 260,
      height: 260,
      frameBorder: 0,
      tabIndex: -1
    }), /*#__PURE__*/jsx("h2", {
      className: subheadingCls,
      children: "Dit forl\xF8b er tomt"
    }), /*#__PURE__*/jsx("p", {
      className: bodyCls,
      children: "Tilf\xF8j indhold ved at klikke p\xE5 plusset ved det \xF8nskede element inde p\xE5 siden"
    })]
  });
});

export { Empty };
//# sourceMappingURL=empty.js.map
